import { DisputeStatusLabel } from './constants';
import texts from './texts.json';

export const isPartiallyRefunded = (charge) => !!charge
  && !charge.refunded
  && (charge.amountRefunded || 0) > 0;

export const getInvoiceStatusLabel = (invoice) => {
  const { charge, status } = invoice;
  if (charge?.refunded) {
    return texts.refundedStatus;
  }
  if (isPartiallyRefunded(charge)) {
    return texts.partiallyRefundedStatus;
  }
  if (charge?.disputed) {
    return DisputeStatusLabel[charge.disputeStatus] ?? texts.emptyText;
  }
  return status;
};
